(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('payment-details', {
            parent: 'entity',
            url: '/payment-details/{paymentId}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Payment Details'
            },
            resolve: {
                billingAccess: ['BillingAccess', function(BillingAccess) {
                    return BillingAccess.requireAccess();
                }]
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/payment-details/payment-details.html',
                    controller: 'PaymentDetailsController',
                    controllerAs: 'vm'
                }
            },
        });
    }

})();
